import { Divider, Skeleton } from '@reveni-io/reveni-ui'

import * as Styles from './styles'

const EmailTemplatesConfigurationSkeleton = () => {
  return (
    <Styles.Container>
      <Skeleton variant="text" width={220} height={28} />
      <Skeleton variant="text" width="100%" height={20} />
      <Skeleton variant="rounded" width="100%" height={48} />

      <Styles.TemplatesList>
        {Array.from({ length: 5 }).map((_, index) => (
          <Styles.TemplateRow key={index}>
            <Skeleton variant="rounded" width={24} height={24} />
            <Styles.TemplateBox>
              <Skeleton variant="text" width={220} height={20} />
              <Skeleton variant="text" width="60%" height={16} />
            </Styles.TemplateBox>
            <Skeleton variant="rounded" width={48} height={24} />
            <Skeleton variant="circular" width={24} height={24} />
          </Styles.TemplateRow>
        ))}
      </Styles.TemplatesList>

      <Divider />

      <Styles.LoadMoreContainer>
        <Skeleton variant="rounded" width={160} height={32} />
      </Styles.LoadMoreContainer>

      <Skeleton variant="rounded" width={200} height={32} />
    </Styles.Container>
  )
}

export default EmailTemplatesConfigurationSkeleton
